var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"bamsvgicon",staticClass:"o-svg-icon",style:(_vm.style),domProps:{"innerHTML":_vm._s(
    require(("!!html-loader!./../../../assets/inlineSvgs/" + (_vm.$slots.default[0].text.trim()) + ".svg"))
  )}})}
var staticRenderFns = []

export { render, staticRenderFns }